export default class ApiResponseModel {
	data?: any = undefined;
	error?: string = undefined;
	isSuccessful: boolean = false;
	status?: number = undefined;
}
